import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  calculateTotalBankroll,
  calculateOpenBets
} from 'utils/calculations'
import { Link } from 'react-router'
import { currencyToText } from 'utils/converters'
import { logout } from 'actions/auth'
import StatusModal from 'components/analytics/statusModal'

class Topbar extends Component {

  constructor(props) {
    super(props)
    this.logout = this.logout.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.showModal = this.showModal.bind(this)
    this.state = {
      showModal: false
    }
  }

  logout(e) {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch(logout())
  }

  closeModal() {
    this.setState({
      showModal: false
    })
  }

  showModal() {
    this.setState({
      showModal: true
    })
  }

  render() {
    let { numBets, moneyInPlay } = calculateOpenBets(this.props.userbets, this.props.currencies, this.props.user.currency)
    return (
      <div className="row header">
        <div className="content">
        <StatusModal closeModal={this.closeModal} showModal={this.state.showModal} bets={this.props.userbets} mainCurrency={this.props.user.currency} currencies={this.props.currencies} startingBankroll={this.props.user.startingBankroll} />
          <div className="col-xs-4 value hidden-xs">
            <span>BANKROLL: </span><strong>{ currencyToText(calculateTotalBankroll(
              this.props.user.startingBankroll,
              this.props.userbets,
              this.props.currencies,
              this.props.user.currency), this.props.user.currency) }</strong>
          </div>
          <div className="col-xs-3 value hidden-xs">
            <span>OPEN BETS: </span><strong>{ numBets }</strong>
          </div>
          <div className="col-xs-4 value hidden-xs">
            <span>MONEY IN PLAY: </span><strong>{ currencyToText(moneyInPlay, this.props.user.currency)}</strong>
          </div>
          <div className="col-xs-2 col-sm-1 pull-right">
            <a href="#" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
              <i className="ionicons ion-ios-contact-outline" id='profile-icon'></i><span className='caret'> </span>
            </a>
            <ul className="dropdown-menu profile-menu">
              <li><Link to="/me">Profile</Link></li>
              <li><Link to='/featureboard'>Request a feature <span className='label label-success'>new</span></Link></li>
              <li><a onClick={this.showModal}>Generate Status Report</a></li>
              { (this.props.user.permissionLevel >= 5 || this.props.user.hijacked === true) && <li><Link to='/admin'>Admin panel</Link></li> }
              <li><a href="/logout" onClick={this.logout}>Log out</a></li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    userbets: state.userbets,
    currencies: state.currencies
  }
})(Topbar)



/** WEBPACK FOOTER **
 ** ./src/components/Topbar.js
 **/